import React from 'react'
import { t } from 'i18next'
import { Field } from './Field'
import { Dropdown, Option } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'
import { SNIWorkplaceConnection, Workplace } from '../../../api/schemas/schema'

type ControlledSniDropdownProps = {
   name: any
   control: Control<Workplace>
   label: string
   options: SNIWorkplaceConnection[]
   disabled?: boolean
   required?: boolean
}

export const ControlledSniDropdown = ({ name, control, label, options, disabled, required }: ControlledSniDropdownProps) => {
   return (
      <Controller
         name={name}
         control={control}
         rules={{ required: required ? t('RequiredField') : false }}
         render={({ field: { value, onChange }, fieldState: { error }, formState: { disabled: formDisabled } }) => {
            const selectedOptions = Array.isArray(value) ? value.map((v) => v.sni.id) : []

            return (
               <Field label={label} required={required ?? false} validationMessage={error?.message ?? null} validationState={error ? 'error' : null}>
                  <Dropdown
                     multiselect
                     selectedOptions={selectedOptions}
                     value={
                        Array.isArray(value)
                           ? value
                                .sort((a, b) => (a.sni.code ?? 0) - (b.sni.code ?? 0))
                                .map((sniConn) => sniConn?.sni?.code.toString().padStart(2, '0').padEnd(5, 'xxx'))
                                .join(', ')
                           : ''
                     }
                     onOptionSelect={(e, d) => {
                        const updated = d.selectedOptions
                           .map((id) => options.find((sniConn) => sniConn.sni.id === id))
                           .filter((conn): conn is SNIWorkplaceConnection => !!conn)
                        onChange(updated)
                     }}
                     disabled={(disabled || formDisabled) ?? false}
                  >
                     {options.map((sniConn) => (
                        <Option key={sniConn.sni.id} value={sniConn.sni.id}>
                           {`${sniConn.sni?.code.toString().padStart(2, '0').padEnd(5, 'xxx')} ${sniConn.sni?.comment}`}
                        </Option>
                     ))}
                  </Dropdown>
               </Field>
            )
         }}
      />
   )
}
